import { render } from "./Wellcome.vue?vue&type=template&id=81e5812c"
const script = {}

const cssModules = {}
import style0 from "./Wellcome.vue?vue&type=style&index=0&id=81e5812c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__